import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[numberAndLetterMask]'
})
export class NumberAndLetterMaskDirective {

  @Output() numberChange = new EventEmitter<number>();

  constructor(private el: ElementRef) { }

  value: string;

  @HostListener('input', ['$event']) onInputChange(event) {
    const regex = /^[0-9A-Za-z]+$/g;
    const initalValue = this.el.nativeElement.value;
    this.el.nativeElement.value = initalValue.replace(/[^0-9A-Za-z-]*/g, '');
    if (regex.test(initalValue) || initalValue === '') {
      this.numberChange.emit(event);
    }
  }
}